import { render, staticRenderFns } from "./VMenuContext.vue?vue&type=template&id=0241ba32&scoped=true"
import script from "./VMenuContext.vue?vue&type=script&lang=js"
export * from "./VMenuContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241ba32",
  null
  
)

export default component.exports